
import { useEffect } from 'react';
import { usePrayerGeneration } from './prayer/usePrayerGeneration';
import { usePrayerVoices } from './prayer/usePrayerVoices';

// Export types for components that need to import from this file
export type { PrayerVoice } from './prayer/usePrayerVoices';
export type { PrayerResult } from './prayer/usePrayerGeneration';
export { PRAYER_VOICES } from './prayer/usePrayerVoices';
export type { Scripture } from './prayer/types';

export const usePrayerGenerator = () => {
  // Combine individual hooks
  const {
    prayerRequest,
    setPrayerRequest,
    loading,
    prayerResult,
    generatePrayer
  } = usePrayerGeneration();

  const {
    selectedVoice,
    setSelectedVoice,
    PRAYER_VOICES
  } = usePrayerVoices();

  return {
    // Prayer generation
    prayerRequest,
    setPrayerRequest,
    loading,
    prayerResult,
    generatePrayer,
    
    // Voice selection
    selectedVoice,
    setSelectedVoice,
    PRAYER_VOICES
  };
};
